import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import CompanyInsuranceCarrier from './CompanyInsuranceCarrier';

class BenefitDivision extends DomainObject {
  name;
  companyInsuranceCarrier;

  _relations = {
    companyInsuranceCarrier: CompanyInsuranceCarrier
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      companyInsuranceCarrier: observable,
      displayName: computed
    });

    this.merge(other);
  }

  get displayName() {
    return `${this.companyInsuranceCarrier.name} - ${this.name}`;
  }
}

export default BenefitDivision;
